import { AutogenLayoutCustomFuelSurchargeBuildTable } from "./autogen/AutogenLayoutCustomFuelSurchargeBuildTable";

export class CustomFuelSurchargeBuildTable extends AutogenLayoutCustomFuelSurchargeBuildTable {
}
